module.exports = __webpack_public_path__ + "img/PL10005.a5845e46.png";